<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Résultat non trouvé",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout
  },
}
</script>
<template>
  <Layout>
    <div class="account-pages my-5 pt-5" style="min-height:400px;">
      <div class="container">
        <div class="row">

          <div class="col-lg-12 text-center">
            <div class="text-left mb-5">

              <img class="mb-2" src="@/assets/images/logo-mini-orange.png"  >

              <h3 class="text-warning font-weight-bold text-uppercase mb-2 mt-4">
                PAGE INTROUVABLE
              </h3> 

              <p class="text-dark font-size-16 mt-4">Cette page n'existe pas ou n'existe plus.
                Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée.
                Nous vous invitons à revenir à la page d'accueil de notre site.
              </p>

                <p class="text-dark font-size-16 mt-2">
                  Utilisez la barre de recherche en haut de la page pour rechercher vos produits ou cliquer sur ce lien pour revenir à la <a class="text-warning font-weight-bold" href="/">page d'acceuil</a>. 
                </p>

            </div>
          </div>

        </div>
      </div>
    </div>
  </Layout>













 
</template>

